import {
  Box,
  Typography,
  Chip,
  Paper,
  IconButton
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowForward, LocationOn } from "@mui/icons-material";

const estadoColor = {
  "Pendiente de revisión": "warning",
  "Aprobado": "success",
  "Rechazado": "error"
};

function parsearFecha(fecha) {
  if (!fecha) return "-";
  const f = new Date(fecha);
  const dd = String(f.getDate()).padStart(2, '0');
  const MM = String(f.getMonth() + 1).padStart(2, '0');
  const yyyy = f.getFullYear();
  return `${dd}/${MM}/${yyyy}`;
}

function UPSE4Upse2Item({
  id,
  anio,
  fechaPresentacion,
  techoPresupuestario,
  tipoPlanificacion,
  responsable,
  creado,
  estado,
  lugarPresentacion,
  direccion,
  mesesPlanificados,
  mesesReportados,
  mesesEsperados,
}) {
  const navigate = useNavigate();

  const alDia = mesesEsperados === 0 || mesesReportados >= mesesEsperados;
  const totalParaRatio = Math.max(mesesPlanificados, mesesReportados);

  return (
    <Paper
      elevation={1}
      onClick={() => navigate("/UPSE4MesesPorUpse2", { state: { idUpse2: id, nombreUpse2: direccion || lugarPresentacion, anio, tipoPlanificacion } })}
      sx={{
        px: 2.5,
        py: 1.5,
        mb: 1.5,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
        cursor: "pointer",
        "&:hover": { borderColor: "#bbb", boxShadow: 2 },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, minWidth: 200 }}>
          <Chip label={`U2-${id}`} size="small" variant="outlined" color="primary" />
          <LocationOn fontSize="small" color="action" />
          <Typography variant="body1" fontWeight={600} noWrap>{lugarPresentacion}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography variant="body2" color="text.secondary">{anio}</Typography>
          <Typography variant="body2" fontWeight={500}>Q {techoPresupuestario}</Typography>
          <Chip label={tipoPlanificacion} size="small" variant="outlined" sx={{ textTransform: "capitalize" }} />
        </Box>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        Planificación: U2-{id}
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        Creado por: {creado} · Revisor: {responsable}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 1, flexWrap: "wrap", gap: 1 }}>
        <Typography variant="caption" color="text.secondary">
          {parsearFecha(fechaPresentacion)}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Chip label={estado} size="small" color={estadoColor[estado] || "default"} />
          <Typography variant="body2" color="text.secondary">
            {mesesReportados}/{totalParaRatio} meses reportados
          </Typography>
          <Chip
            label={alDia ? "Al día" : "Atrasado"}
            size="small"
            color={alDia ? "success" : "warning"}
          />
          <IconButton size="small" color="primary">
            <ArrowForward fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
}

export { UPSE4Upse2Item };
